<div class="report-item p-3">
  <div class="d-flex justify-content-between align-items-start">
    <div class="d-flex align-items-start gap-3 flex-grow-1">

      <!-- Report Icon -->
      <div class="report-icon" [ngClass]="'status-' + report.status">
        <i class="bi" [ngClass]="reports.getStatusIcon(report.status)"
           [class.spin]="report.status === 'generating'"></i>
      </div>

      <!-- Report Details -->
      <div class="flex-grow-1">
        <div class="d-flex align-items-center gap-2 mb-1 flex-wrap">
          <h6 class="mb-0 fw-medium">{{ report.name }}</h6>
          <span class="badge" [ngClass]="report.status | statusBadge:'report'">
            <i class="bi me-1" [ngClass]="reports.getStatusIcon(report.status)"
               [class.spin]="report.status === 'generating'"></i>
            {{ reports.getStatusText(report.status) }}
          </span>
        </div>
        <div class="small text-muted mb-1">
          <ng-container *ngIf="reports.formatReportDates(report) as dateRange">{{ dateRange }} • </ng-container>
          {{ reports.getScopeLabel(report.scope) }}
        </div>

        <!-- Progress bar for generating status -->
        <div *ngIf="report.status === 'generating'" class="progress-container mb-2">
          <div class="progress" style="height: 6px;">
            <div class="progress-bar progress-bar-striped progress-bar-animated"
                 role="progressbar"
                 [style.width.%]="report.generationProgress || 0"
                 [attr.aria-valuenow]="report.generationProgress || 0"
                 aria-valuemin="0"
                 aria-valuemax="100">
            </div>
          </div>
          <span class="small text-muted">{{ report.generationProgress || 0 }}% complete</span>
        </div>

        <!-- Error message for failed reports -->
        <div *ngIf="report.status === 'failed' && report.errorMessage" class="error-info mb-1">
          <span class="small text-danger">
            <i class="bi bi-exclamation-circle me-1"></i>
            {{ report.errorMessage }}
          </span>
        </div>
      </div>
    </div>

    <!-- Actions -->
    <div class="flex-shrink-0 ms-3">
      <div class="d-flex align-items-center gap-2">
        <ng-container [ngSwitch]="report.status">
          <ng-container *ngSwitchCase="'generating'">
            <button class="btn btn-sm btn-outline-secondary" disabled>
              <span class="spinner-border spinner-border-sm me-1"></span>
              Generating...
            </button>
          </ng-container>

          <ng-container *ngSwitchCase="'ready'">
            <button class="btn btn-sm btn-outline-primary" (click)="download.emit(report)" title="Download PDF">
              <i class="bi bi-download"></i>
            </button>
          </ng-container>

          <ng-container *ngSwitchCase="'failed'">
            <button class="btn btn-sm btn-warning" (click)="retry.emit(report)">
              <i class="bi bi-arrow-clockwise me-1"></i>Retry
            </button>
          </ng-container>
        </ng-container>

        <!-- Delete (always available except during generation) -->
        <button *ngIf="report.status !== 'generating'"
                class="btn btn-sm btn-outline-danger"
                (click)="remove.emit(report)"
                title="Delete">
          <i class="bi bi-trash"></i>
        </button>
      </div>
    </div>
  </div>
</div>
